import React from 'react'
import { useAppDispatch, useAppSelector } from '@SonarCX/hooks/redux'

import PinnedTab from '@SonarCX/components/molecules/PinnedTab'

import { selectPinnedTabs, loadPinnedTabs } from '@SonarCX/slices/pinnedTabs'
import { useEnvironment } from '@SonarCX/providers/EnvironmentProvider'
import useStyles from './styles'

type PinnedTabsProps = {
  useModalWidth: number
}

const PinnedTabs: React.FC<PinnedTabsProps> = ({ useModalWidth }) => {
  const dispatch = useAppDispatch()

  const { dbLoaded, tabs } = useAppSelector(selectPinnedTabs)

  const { user, env, loaded: envLoaded } = useEnvironment()

  const classes = useStyles({ useModalWidth })

  // Load items from indexedDB
  React.useEffect(() => {
    if (!user?.id || !envLoaded || dbLoaded) {
      return
    }

    dispatch(loadPinnedTabs(user.id, env.name))
  }, [user, envLoaded, dbLoaded, dispatch, env])

  return (
    <div className={classes.root}>
      {tabs.map((tab, i) => (
        <PinnedTab key={tab.id} tab={tab} isLast={i === tabs.length - 1} />
      ))}
    </div>
  )
}

export default PinnedTabs
